import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Registrering from "@/pages/Registrering";
import Takk from "@/pages/Takk";
import Vilkar from "@/pages/Vilkar";
import Personvern from "@/pages/Personvern";
import AdminLogin from "@/pages/AdminLogin";
import Kupong from "@/pages/Kupong";
import Bekreft from "@/pages/Bekreft";
import MinKupong from "@/pages/MinKupong";
import Start from "@/pages/Start";
import LoggInn from "@/pages/LoggInn";
import MineKuponger from "@/pages/MineKuponger";
import AdminLayout from "@/pages/admin/AdminLayout";
import Oversikt from "@/pages/admin/Oversikt";
import Kunder from "@/pages/admin/Kunder";
import Kampanjer from "@/pages/admin/Kampanjer";
import Resultater from "@/pages/admin/Resultater";

function ProtectedRoute({ children }) {
  const { admin } = useAuth();
  if (admin === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1A1715] text-[#A8A29E]">
        Laster…
      </div>
    );
  if (!admin) return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  useEffect(() => {
    document.title = "Demo Bordverket";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/gave" replace />} />
            <Route path="/gave" element={<Start />} />
            <Route path="/gave/registrer" element={<Registrering />} />
            <Route path="/logg-inn" element={<LoggInn />} />
            <Route path="/mine-kuponger" element={<MineKuponger />} />
            <Route path="/gratis-forrett" element={<Navigate to="/gave" replace />} />
            <Route path="/bekreft" element={<Bekreft />} />
            <Route path="/min-kupong" element={<MinKupong />} />
            <Route path="/takk" element={<Takk />} />
            <Route path="/vilkar" element={<Vilkar />} />
            <Route path="/personvern" element={<Personvern />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Oversikt />} />
              <Route path="kunder" element={<Kunder />} />
              <Route path="kampanjer" element={<Kampanjer />} />
              <Route path="resultater" element={<Resultater />} />
            </Route>
            <Route path="/kupong/:token" element={<Kupong />} />
            <Route path="*" element={<Navigate to="/gave" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#282421",
              color: "#FDFBF7",
              border: "1px solid rgba(212,175,55,0.25)",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
